import { triggerClickAnalytics } from "@/components/Remedy/analytics"

export const handleRegisterPreorderAnalytics = (
  textTitle = "",
  cta = "",
  url = ""
) => {
  const title = textTitle?.toLocaleLowerCase()
  const ctaText = cta?.toLocaleLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `pxp:${title}:${ctaText}`,
    eventMsg: "n/a",
    eventName: `pxp:${title}:${ctaText}`,
    eventStatus: "n/a",
    eventType: "teaser",
    internalLinkName: `${ctaText}`,
    internalLinkPosition: `pxp:${ctaText}:teaser`,
    internalLinkType: `pxp:${title}`,
    internalLinkURL: url,
    internalLinkZoneName: `pxp:${title}`,
  }
  triggerClickAnalytics(eventInfo)
  window.location.href = url
}

export const handleVideoPlayedAnalytics = (
  title = "",
  videoUrl = "",
  autoplay = true,
  videoId = ""
) => {
  const videoTitle = title?.toLocaleLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `pxp:${videoTitle}:video play`,
    eventMsg: "n/a",
    eventName: `pxp:${videoTitle}:video play`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: "video play",
    internalLinkPosition: `pxp:${videoTitle}:teaser`,
    internalLinkType: `pxp:${videoTitle}`,
    internalLinkURL: videoUrl,
    internalLinkZoneName: `pxp:${videoTitle}`,
    videoName: videoTitle,
    videoId,
    videoType: autoplay ? "auto play" : "user initiated",
  }
  triggerClickAnalytics(eventInfo)
}

export const handleVideoEndedAnalytics = (
  title = "",
  videoUrl = "",
  autoplay = true,
  videoId = ""
) => {
  const videoTitle = title?.toLocaleLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `pxp:${videoTitle}:video complete`,
    eventMsg: "n/a",
    eventName: `pxp:${videoTitle}:video complete`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: "video complete",
    internalLinkPosition: `pxp:${videoTitle}:teaser`,
    internalLinkType: `pxp:${videoTitle}`,
    internalLinkURL: videoUrl,
    internalLinkZoneName: `pxp:${videoTitle}`,
    videoName: videoTitle,
    videoId,
    videoType: autoplay ? "auto play" : "user initiated",
  }
  triggerClickAnalytics(eventInfo)
}

export const handleFAQAnalytics = (textTitle = "", expand = true) => {
  const title = textTitle?.toLocaleLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `pxp:icebath faqs:${title}:${expand ? "expand" : "collapse"}`,
    eventMsg: "n/a",
    eventName: `pxp:icebath faqs:${title}:${expand ? "expand" : "collapse"}`,
    eventStatus: "n/a",
    eventType: "accordion",
    internalLinkName: expand ? "expand" : "collapse",
    internalLinkPosition: `pxp:${title}:accordion`,
    internalLinkType: "pxp:icebath faqs",
    internalLinkURL: "n/a",
    internalLinkZoneName: "pxp:icebath faqs",
  }
  triggerClickAnalytics(eventInfo)
}
